<template>
  <div>
    <!-- 服务商 -->
    <div class="detail-wrap">
      <el-form ref="editForm" :model="formData">
        <div class="d-header">
          <div class="fl">
            <i class="el-icon-info" />
            {{ dataId ? '查看' : '新增' }}优惠卷
          </div>
          <div class="fr">
            <el-button type="primary"  class="button-sty" icon="el-icon-check" v-if="formData.stat == 1&&formData.id!=null" @click="handleCommand('审核',formData.id)">审核</el-button>
            <el-button type="primary"  class="button-sty" icon="el-icon-check" v-if="formData.stat == 1&&formData.id!=null" @click="handleCommand('作废',formData.id)">作废</el-button>
            <el-button type="primary"  class="button-sty" icon="el-icon-check" v-if="formData.stat == 1 || formData.id==null " @click="saveData(formData.id)">保存</el-button>
          </div>

          <!-- <div style="display:none">
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-thumb">指派中心
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-chat-line-square">
              用户催单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-tickets">工单跟进
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-delete">
              关闭工单
            </el-button>
            <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-document-copy">打印工单
            </el-button>
          </div> -->
          <!-- <div class="fr" style="display:none">
            <el-button type="primary" class="button-sty" icon="el-icon-check"
              v-if="formData.stat == 1 || formData.stat == 0" @click="saveData">保存
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="formData.stat == 1"
              @click="showAuditDialog = true">审核
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-refresh-right" v-if="formData.stat == 1"
              @click="showCloseDialog = true; isCancel = false">驳回
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close" v-if="formData.stat == 1"
              @click="showCloseDialog = true; isCancel = true">取消
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-check" v-if="formData.stat == 2"
              @click="showOutboundDialog = true">发货
            </el-button>
            <el-button type="primary" class="button-sty" icon="el-icon-close" v-if="formData.stat == 2"
              @click="showCloseDialog = true">中止
            </el-button>
          </div> -->
        </div>

        <div>

          <!-- 基本信息 -->
          <dix style="overflow: unset!important;overflow-y: scroll!important;height: 100vh!important;display: block ">
            <div class="d-cont edit-mce-box">
              <div class="d-item">
                <div class="title first"><b>主信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        优惠卷名称
                      </th>
                      <td><el-input type="text" autocomplete="off" v-model="formData.couponName" clearable /></td>
                      <th>
                        <em class="f-red">*</em>
                        优惠卷金额
                      </th>
                      <td><el-input type="text" maxlength="8"  autocomplete="off" v-model="formData.couponAmount" clearable />
                      </td>
                      <th>
                        <em class="f-red">*</em>
                        发放总量
                      </th>
                      <td><el-input type="text" maxlength="6" autocomplete="off" v-model="formData.qty" clearable /></td>
                      <th>
                        <em class="f-red">*</em>
                        每人限领张数
                      </th>
                      <td><el-input type="text" maxlength="4" autocomplete="off" v-model="formData.limitQty" clearable /></td>
                    </tr>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        状态
                      </th>
                      <td>
                        <el-select v-model="formData.stat" clearable :disabled="formData.stat">
                          <el-option label="待审核" :value="1" />
                          <el-option label="已审核" :value="2" />
                          <el-option label="作废" :value="9" />
                        </el-select>
                      </td>
                    </tr>
                    <tr>
                      <th>
                        创建人
                      </th>
                      <td>{{ formData.createBy }}</td>
                      <th>
                        创建时间
                      </th>
                      <td>{{ formData.createTime }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>使用信息</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>
                        <em class="f-red">*</em>
                        已发放数量
                      </th>
                      <td><el-input type="text" maxlength="6" autocomplete="off" v-model="formData.sendQty" :value ="0" :disabled = true  clearable/></td>
                      <th>
                        <em class="f-red">*</em>
                        未发放数量
                      </th>
                      <td><el-input type="text" maxlength="6" autocomplete="off" v-model="formData.unSendQty" :value ="0"  :disabled = true clearable/></td>
                      <th>
                        <em class="f-red">*</em>
                        已使用数量
                      </th>
                      <td><el-input type="text" maxlength="6" autocomplete="off" v-model="formData.usedQty" :value ="0" :disabled = true clearable/></td>
                      <th>
                        <em class="f-red">*</em>
                        未使用数量
                      </th>
                      <td><el-input type="text" maxlength="6" autocomplete="off" v-model="formData.unUsedQty" :value ="0"  :disabled = true clearable/></td>
                    </tr>          
                  </tbody>
                </table>
              </div>
              <div class="d-item">
                <div class="title first"><b>使用条件</b></div>
                <table class="table-detail">
                  <tbody>
                    <tr>
                      <th>指定范围</th>
                      <td colspan="3" style="width: 26vw!important;">
                        <el-radio-group v-model="formData.effectiveRange" @change="agreeChange">
                        <el-radio  :label="1">全部产品</el-radio>
                        <el-radio  :label="2">特定产品</el-radio>
                        <el-radio  :label="3">特定品类</el-radio>
                      </el-radio-group>
                      </td>
                    </tr>
                    <tr>
                      <th>满减门槛</th>
                      <td colspan="3">
                        <el-radio v-model="formData.usedRange" :label="0">无门槛</el-radio>
                        <el-radio v-model="formData.usedRange" :label="1">有门槛</el-radio>
                      </td>
                      <th>
                      满减金额
                      </th>
                      <td><el-input type="number" autocomplete="off" v-model="formData.usedRangeAmount" :value ="0" clearable  :disabled="!formData.usedRange"  /></td>
                    </tr>
                    <tr>
                      <th>使用时间</th>
                      <td colspan="3" >
                        <el-radio v-model="formData.timeRange" :label="1" >按天数</el-radio>
                        <el-radio v-model="formData.timeRange" :label="2" >按时间段</el-radio>
                      </td>
                   
                    </tr>
                    <tr>
                      <th>
                        使用天数
                      </th> 
                      <td><el-input type="text" maxlength="4" autocomplete="off" v-model="formData.timeRangeNumber" :value ="0" clearable  :disabled="formData.timeRange>1"/></td> 
                         <th>
                        使用开始时间
                      </th>
                      <td>
                        <!-- <el-input type="text" autocomplete="off" v-model="formData.sendQty" clearable  :disabled="formData.timeRange<=1" /> -->
                        <el-date-picker v-model="formData.timeRangeBegin" type="date" placeholder="选择日期" :disabled="formData.timeRange<=1">
                        </el-date-picker>
                      </td>
                      <th>
                        使用结束时间
                      </th>
                      <!-- <td><el-input type="text" autocomplete="off" v-model="formData.sendQty" clearable  :disabled="formData.timeRange<=1" /> -->
                        <td>
                        <el-date-picker v-model="formData.timeRangeEnd" type="date" placeholder="选择日期" :disabled="formData.timeRange<=1">
                        </el-date-picker></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-item" v-if="Range==2">
                <div class="title first">
                  <b>特定产品列表</b>
                  <div style="float: right;">      
                    <el-button type="primary" class="button-sty btn_zdy" @click="showCouponItemDialog=true">
                    <i class="el-icon-plus"></i>新增</el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="deleteItemData" style="margin-left: 15px;">
                    <i class="el-icon-plus"></i>删除</el-button></div>
                </div>
                <vxe-table :stripe="true" 
                  :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                  :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                  show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                  :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                  :data="formData.slCouponRangeDTOList" 
                  @checkbox-all="selectChangeEvent"
                  @checkbox-change="selectChangeEvent" >
                  <vxe-column type="checkbox" width="60"></vxe-column>
                  <vxe-column field="bigCategory" title="产品大类" width="180" />
                  <vxe-column field="smallCategory" title="产品小类" width="280" />
                  <vxe-column field="itemCode" title="产品编码" width="180" />
                  <vxe-column field="itemName" title="产品名称" width="280" />
                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a href="javascript:void(0);" class="a-link" @click="deleteOneItemData(row)">
                        <el-tooltip effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-delete" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>
              </div>
              <div class="d-item" v-if="Range==3">
                <div class="title first">
                  <b>特定品类列表</b>
                  <div style="float: right;">      
                    <el-button type="primary" class="button-sty btn_zdy" @click="showCouponItemDialog = true;">
                    <i class="el-icon-plus"></i>
                    新增
                  </el-button>
                  <el-button type="primary" class="button-sty btn_zdy" @click="deleteItemData" style="margin-left: 15px;">
                    <i class="el-icon-plus"></i>
                    删除
                  </el-button></div>
            
                </div>
                <vxe-table :stripe="true" 
                  :header-cell-style="{ background: '#F6FAFF', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080' }"
                  :header-row-style="{ height: '36px' }" :row-style="{ fontSize: '12px', background: '#fff' }"
                  show-overflow keep-source :row-config="{ height: 36 }" ref="xTable" height="150"
                  :column-config="{ resizable: true }" :edit-config="{ trigger: 'click', mode: 'cell', showStatus: true }"
                  :data="formData.slCouponRangeDTOList" 
                  @checkbox-all="selectChangeEvent"
                  @checkbox-change="selectChangeEvent">
                  <vxe-column type="checkbox" width="60"></vxe-column>
                  <vxe-column field="bigCategory" title="产品大类" width="180" />
                  <vxe-column field="smallCategory" title="产品小类" width="280" />
                  <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a href="javascript:void(0);" class="a-link" @click="deleteOneItemData(row)">
                        <el-tooltip effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-delete" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>
                </vxe-table>


              </div>

              <div class="d-item">
                <div style="display: flex;justify-content: space-between;">
                  <div class="title first"><b>发放记录</b></div>
                  <div class="item-button" style="margin-top: 8px;">
                    <div style="float: right;"> <!-- v-if="!justShow"  -->
                      <el-button type="primary" class="button-sty btn_zdy" @click="oneGrantDialog=true" v-if="formData.stat == 1 || formData.id==null"> 
                      <i class="el-icon-plus"></i>
                        单个发放
                      </el-button>&nbsp;
                      <el-button type="primary" class="button-sty btn_zdy" @click="$refs.excelUpload.show()" v-if="formData.stat == 1&&formData.id!=null">
                      <i class="el-icon-plus"></i>
                        批量发放
                      </el-button>&nbsp;
                      <el-button type="primary" class="button-sty btn_zdy" @click="batchDeleteData" v-if="formData.stat == 1 || formData.id==null">
                      <i class="el-icon-delete"></i>
                        批量删除
                      </el-button></div>
                   
                  </div>
                </div>
                <div>
                  <vxe-table style="margin-top: 0px;" :stripe="true"
                    :header-cell-style="{ height: '30px', background: '#EFF6FC', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
                    :row-config="{ height: 30, isHover: true, padding: 0, }" :row-style="{ fontSize: '12px', }"
                    show-overflow height="110" :column-config="{ resizable: true }" 
                    :data="formData.slCouponListDTOList"
                    @checkbox-all="selectChangeEvent"
                    @checkbox-change="selectChangeEvent">
                    <vxe-column type="checkbox" width="40" />
                    <vxe-column field="couponListNo" title="优惠卷号" width="150"></vxe-column>
                    <vxe-column field="engineerCode" title="工程师工号" width="150"></vxe-column>
                    <vxe-column field="engineerMobile" title="工程师手机"></vxe-column>
                    <vxe-column field="createBy" title="发放人"></vxe-column>
                    <vxe-column field="createTime" title="发放时间"></vxe-column>
                    <vxe-column field="stat" title="使用状态">
                      <template #default="{row}">
                        <span v-if="row.stat==0">未使用</span>
                        <span v-else-if="row.stat==1">已使用</span>
                      </template>
                    </vxe-column>
                    <vxe-column field="dateTime" title="使用时间"></vxe-column>
                    <vxe-column title="操作" width="50">
                    <template #default="{ row }">
                      <a href="javascript:void(0);" class="a-link" v-if="row.stat==0&&formData.stat==1" @click="deleteOneEngineerData(row)">
                        <el-tooltip effect="dark" content="删除" placement="top" popper-class="tooltip-skin">
                          <i class="el-icon-edit" />
                        </el-tooltip>
                      </a>
                    </template>
                  </vxe-column>


                  </vxe-table>
                </div>
              </div>

              <div style="height:160px"></div>
            </div>
            <!-- <div style="width: 20%; height: 100%" class="bread">
              <div style="padding-bottom: 90px;  height: 100%;  margin-top: 10px; margin-left: 5px;">
                <div class="title_icon"><i class="el-icon-date"></i></div>
                <span>申请过程</span>
                <el-timeline class="card_bread" style="height:100%; position:relative">
                  <el-timeline-item v-for="item in formData.spPartsApplyOperationDTOList" placement="top">
                    <div class="title_time"><span class="span1">{{ item.title }}</span>
                      <span class="span2">{{ item.createTime }}</span>
                    </div>
                    <el-card class="card">
                      <p>{{ item.content }}</p>
                    </el-card>
                  </el-timeline-item>

                </el-timeline>

              </div>
            </div> -->
          </dix>

        </div>


      </el-form>
      <!-- 服务区域弹窗表 -->
    </div>
    <!-- <sitePop v-if="showSitePop" @commit="siteCommit" :visiable.sync="showSitePop" multi="true" /> -->

    <!-- <orderPop v-if="showOrderPop" @commit="orderCommit" :visiable.sync="showOrderPop" :siteId="formData.siteId"
      multi="true" />

    <warehousePop v-if="showWarehousePop" :warehouseType="warehouseType" @commit="warehouseCommit"
      :visiable.sync="showWarehousePop" multi="true" />

    <partsInvPop v-if="showPartsInvPop" @confirm="confirm" :visiable.sync="showPartsInvPop" multi="true" />

    <auditDialog v-if="showAuditDialog" :form-data="formData" :shippingMethodList="shippingMethodList" @closeD="closeD"
      :visiable.sync="showAuditDialog" multi="true" @goBackIndex="goBackIndex" />

    <outboundDialog v-if="showOutboundDialog" :form-data="formData" :shippingMethodList="shippingMethodList"
      :logisticsCompaniesList="logisticsCompaniesList" @closeD="closeD" :visiable.sync="showOutboundDialog" multi="true"
      @goBackIndex="goBackIndex" />

    <closeDialog v-if="showCloseDialog" :dataId="formData.id" :stat="formData.stat" @closeD="closeD"
      :visiable.sync="showCloseDialog" multi="true" @goBackIndex="goBackIndex" :isCancel="isCancel" /> -->


    <!-- 产品弹窗 -->
    <checkboxItemDialog :visiable.sync="showCouponItemDialog" v-if="showCouponItemDialog"
                          :param="{excludePartsIds: this.formData.slCouponRangeDTOList.map(item => item.partsId)}"
                          @confirm="commitSelectedItemRow" />
    <!-- 单据列表-->
    <recordDialog v-if="showAreaDialog" @commitData="commitAreaData" :areaObj="areaObj" :visiable.sync="showAreaDialog" multi="true" />

    <!-- 工程师列表 -->
    <grantDialog :visiable.sync="oneGrantDialog" v-if="oneGrantDialog" 
                  @commit="commitSelectedRow" />

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
        <span>{{dialogMsg}}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmCheck()">确 定</el-button>
        </span>
    </el-dialog>

    <!--excel 模板导入 -->
    <excel-upload
      ref="excelUpload"
      title="优惠卷批量发放导入"
      url="/basic/slCoupon/import"
      temp-url="/admin/sys-file/local/file/couponInfo.xlsx"
      @refreshDataList="getData"
    ></excel-upload>
 
  </div>
</template>

<script>
import store from "@/store";
import api from "@/api/projectApi";
import { echoFileFormat, uploadFileFormat } from "@/util/uploadFormat";
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue'
import orderPop from '@/views/dialogCommon/radioOrderDialog.vue'
import warehousePop from '@/views/dialogCommon/radioWarehouseDialog.vue'
import { dictType, loadDictData } from "@/config/dictType";
import partsInvPop from '@/views/dialogCommon/partsInvDialog.vue';
import auditDialog from "./auditDialog.vue";
import closeDialog from "./closeDialog.vue";
import outboundDialog from "./outboundDialog.vue";
import grantDialog from '@/views/dialogCommon/radioEngineerDialog.vue';
// 单据列表
import recordDialog from './recordDialog';

// 产品弹窗
import checkboxItemDialog from "@/views/dialogCommon/checkboxItemDialog.vue";

import ExcelUpload from "@/components/upload/excel";


export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number],
    type: String
  },
  recordDialog,
  components: { auditDialog, closeDialog, outboundDialog, orderPop, sitePop, warehousePop, partsInvPop,
                checkboxItemDialog,recordDialog,grantDialog,ExcelUpload },
  data() {
    return {
      excelUpload: false,
      Range:1,
      oneGrantDialog: false,
      batchGrant: false,
      showCouponItemDialog: false,
  
      showAreaDialog: false,

      warehouseType: 0,
      justShow: false,
      showPartsInvPop: false,
      showSitePop: false,
      showOrderPop: false,
      showWarehousePop: false,
      showAuditDialog: false,
      showOutboundDialog: false,
      showCloseDialog: false,
      isCancel: false,
      orgOptions: [],
      orgValue: '',
      areaOption: [],
      areaValues: [],
      selectedData: [],
      
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      // shippingMethodList: [],
      // logisticsCompaniesList: [],
      // picList1: [],
      // picList2: [],
      // picList3: [],
      // showPhotoList: [],
      formData: {
        sendQty:0,
        unSendQty:0,
        usedQty:0,
        unUsedQty:0,
        couponAmount:0,
        qty:1,
        limitQty:1,
        stat:1,
        effectiveRange:1,
        usedRange:0,
        timeRange:1,
        timeRangeNumber:0,
        usedRangeAmount:0,
        slCouponListDTOList:[],
        slCouponRangeDTOList:[],
      },

      show3: false,
      node: true,
      dialogMsg: null,
      dialogVisible: false,

      srcList: [],

      ////////////////////////////////////////////////////////////////////////////////////////////

      isEdit: false,
      tabIndex: 'first',
      dataId: '',


    };
  },
  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  mounted() {
    this.getData()
    // this.loadOrgData()
    // this.loadDictData()

  },
  watch: {
    // selectedRow: {
    //   handler(newVal, oldVal) {
    //     this.formData.itemId = newVal.id
    //     this.formData.itemCode = newVal.code
    //     this.formData.itemName = newVal.name
    //   },
    //   deep: true
    // },
    // 'formData.outType': {
    //   handler(n) {
    //     if (n == 1) {  // 总部
    //       this.warehouseType = 0
    //     } else if (n == 2) {   // 中心
    //       this.warehouseType = 1
    //     }
    //   },
    //   deep: true
    // },
    // 'formData.spPartsApplyLineDTOList': {
    //   handler(n) {
    //     if (n) {
    //       let temp = 0
    //       let temp1 = 0
    //       n.forEach(item => {
    //         temp += Number(item.applyQty)
    //         temp1 += Number(item.applyQty) * Number(item.sitePrice)
    //       })
    //       this.formData.applyQtyAll = temp
    //       this.formData.applyAmountAll = temp1
    //     }
    //   },
    //   deep: true
    // }
  },
  methods: {
    commit(data) {
      console.log(data, '弹框选中')
      let temp = []
      data.forEach(item => {
        temp.push({
          id: -new Date().getTime() + Math.floor(Math.random() * 1000),
          packageItemId: item.id,
          brandName: item.brandName,
          itemCode: item.itemCode,
          itemName: item.itemName,
          itemModel: item.itemModel,
          packageQty: 1,
          isNew: true
        })
      })
    },

    agreeChange(val){
      console.log(val,"val的值11111");
      var val=val
      if(val==2){
        this.Range=2
      }else if(val==3){
        this.Range=3
      }  else{
        this.Range=1
      }   
    },

    handleCommand(command, id) {
      this.currentRowId = id
      console.log(command, id, "command,b的值");
      if (command === '审核') {
        this.dialogMsg = '确定审核吗？'
        this.stat = 1
        this.dialogVisible = true
      }else if(command === '作废'){
        this.dialogMsg = '确定作废吗？'
        this.stat = 9
        this.dialogVisible = true
      }
    },

    commitSelectedItemRow(data) {
      console.log('产品数据====>',data)
      data = data.map(item => {
        return {
          itemId: item.id,
          smallCategoryId: item.smallCategoryId,
          bigCategoryId: item.bigCategoryId,
          itemName: item.itemName,
          itemCode: item.itemCode,
          smallCategory: item.smallCategoryName,
          bigCategory: item.bigCategoryName,
          isNew: true
        }
      })
      this.formData.slCouponRangeDTOList.push(...data)
    },

    //工程师发放
    commitSelectedRow(data) {
      console.log('工程师数据====>',data)
      this.formData.slCouponListDTOList.push(data)
    },

    // 产品列表批量删除
    deleteItemData() {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        let temp = this.formData.slCouponRangeDTOList
        this.selectedData.forEach(item => {
          temp = temp.filter(item1 => item1.partsId != item.partsId)
        })
        this.formData.slCouponRangeDTOList = temp
      
      })
    },

    // 产品列表单个删除
    deleteOneItemData(row){
      this.formData.slCouponRangeDTOList.splice(row, 1);
    },

    // 发放记录批量删除
    batchDeleteData() {
      this.$baseConfirm('您确定要删除吗？').then(() => {
        let temp = this.formData.slCouponListDTOList
        this.selectedData.forEach(item => {
          temp = temp.filter(item1 => item1.engineerId != item.engineerId)
        })
        this.formData.slCouponListDTOList = temp
      })
    },

    // 发放记录单个删除
    deleteOneEngineerData(row){
      this.formData.slCouponListDTOList.splice(row, 1);
    },
    
    // 单个事务单据选中
    // areaSelect2(data) {
    //   console.log(data, '选中')
    //   if (data.checked) {
    //     this.area2.checkedArray.push(data.row)
    //   } else {
    //     this.area2.checkedArray = this.area2.checkedArray.filter(item => item.id !== data.row.id)
    //   }
    //   console.log('askdfksd', this.area2.checkedArray)
    // },

    // 事务单据全选
    // areaSelectAll2(selection) {
    //   console.log(selection, "工作履历全选")
    //   this.area2.checkedArray = []
    //   let records = selection.records
    //   records.forEach(item => {
    //     this.area2.checkedArray.push(item)
    //   })
    //   console.log(this.area2.checkedArray.length)
    // },
  
    // 返回列表页
    goBackIndex() {
      this.$emit('goBackIndex')
    },

    // 抽屉关闭
    // closeD() {
    //   this.showAuditDialog = false
    //   this.showCloseDialog = false
    //   this.showOutboundDialog = false
    // },

    selectChangeEvent(data) {
      console.log('选中数据', data)
      this.selectedData = data.records
    },

    // 加载数据字典中物流公司，运输方式
    // loadDictData() {
    //   // 物流公司
    //   loadDictData(dictType.logisticsCompanies).then(res => {
    //     this.logisticsCompaniesList = []
    //     res.data.data.forEach(item => {
    //       this.logisticsCompaniesList.push({
    //         label: item.label,
    //         value: item.id
    //       })
    //     })
    //   })

    //   // 运输方式
    //   loadDictData(dictType.shippingMethod).then(res => {
    //     this.shippingMethodList = []
    //     res.data.data.forEach(item => {
    //       this.shippingMethodList.push({
    //         label: item.label,
    //         value: item.id
    //       })
    //     })
    //   })
    // },

    saveData(rowId) {
        if(rowId==null){
          this.$refs.editForm.validate(valid => {
            if (valid) {
              this.$baseConfirm('您确定要保存吗？').then(() => {
                this.$http({
                  url: api.slCoupon.addCouponUrl,
                  method: `post`,
                  data: this.formData,
                  isLoading: true,
                }).then(res => {
                  this.$message.success('保存成功')
                  this.reload()
                  this.$mask.close()
                }).catch(() => {
                  this.$message.error("保存失败！");
                  this.$mask.close()
                });
              });
            }
          });
        }else{
          this.$refs.editForm.validate(valid => {
            if (valid) {
              this.$baseConfirm('您确定要保存吗？').then(() => {
                this.$http({
                  url: api.slCoupon.updateCouponUrl,
                  method: `post`,
                  data: this.formData,
                  isLoading: true,
                }).then(res => {
                  this.$message.success('保存成功')
                  this.reload()
                  this.$mask.close()
                }).catch(() => {
                  this.$message.error("保存失败！");
                  this.$mask.close()
                });
              });
            }
          });
        }
      
    },

    confirmCheck() {
      if(this.stat==1){
        this.$http({
          url: api.slCoupon.checkCouponUrl,
          method: 'post',
          data: {
            id: this.currentRowId,
          }
        }).then(res => {
          this.$message.success('操作成功')
          this.flushed()
        })
        this.dialogVisible = false
      }else if(this.stat==9){
        this.$http({
          url: api.slCoupon.cancelCouponUrl,
          method: 'post',
          data: {
            id: this.currentRowId,
          }
        }).then(res => {
          this.$message.success('操作成功')
          this.flushed()
        })
        this.dialogVisible = false
      }
      
    },

    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.slCoupon.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data;
          this.formData = data
          this.agreeChange(this.formData.effectiveRange)
          this.showPhoto = false
          if (this.justShow) {
            this.showPhotoList0 = [data.proofAttachment1, data.proofAttachment2, data.proofAttachment3]
          } else {
            this.picList1 = echoFileFormat(data.proofAttachment1)
            this.picList2 = echoFileFormat(data.proofAttachment2)
            this.picList3 = echoFileFormat(data.proofAttachment3)
          }
          this.justShow = this.formData.stat != 2
          //流程任务进来的
          if (this.type && this.type == "wf") {
            //只是查看
            this.justShow = true;
          }
          this.showPhoto = true;
          this.getOperationData(data.id)
        })
      }
    },

    // handleImageChange(fileList) {
    //   if (fileList.length > 1) {
    //     fileList.splice(0, 1);
    //   }
    // },
    // handleRemove1() {
    //   this.picList1 = []
    // },
    // handleSuccess1(res, file, fileList) {
    //   console.log(res.data.url, "url")
    //   this.picList1 = echoFileFormat(res.data.url)
    // },
    // handleRemove2() {
    //   this.picList1 = []
    // },
    // handleSuccess2(res, file, fileList) {
    //   console.log(res.data.url, "url")
    //   this.picList2 = echoFileFormat(res.data.url)
    // },
    // handleRemove3() {
    //   this.picList3 = []
    // },
    // handleSuccess3(res, file, fileList) {
    //   console.log(res.data.url, "url")
    //   this.picList3 = echoFileFormat(res.data.url)
    // },

    // handleClick(tab, event) {
    //   console.log(tab, event);
    //   console.log(tab.name, "name得值");
    //   if (tab.index == 0) {
    //     this.card = true
    //   } else {
    //     this.card = false
    //   }
    // },

    // areaconfirm(rows) {
    //   if (rows.length > 0) {

    //     const tableData = this.table_area;
    //     const map = {};
    //     tableData.forEach(function (item) {
    //       map[item.preconditionId] = 1;
    //     });
    //     var items = [];
    //     rows.forEach((row, index) => {
    //       const item = {
    //         preconditionId: row.id,
    //         areaName: row.precondition
    //       };
    //       if (!map[item.preconditionId]) {
    //         items.push(item);
    //       }
    //     });
    //     this.table_area = this.table_area.concat(items);
    //   }
    // },
    // preconditionconfirm(rows) {
    //   if (rows.length > 0) {

    //     const tableData = this.table_type;
    //     const map = {};
    //     tableData.forEach(function (item) {
    //       map[item.preconditionId] = 1;
    //     });
    //     var items = [];
    //     rows.forEach((row, index) => {
    //       const item = {
    //         preconditionId: row.id,
    //         typeName: row.precondition
    //       };
    //       if (!map[item.preconditionId]) {
    //         items.push(item);
    //       }
    //     });
    //     this.table_type = this.table_type.concat(items);
    //   }
    // },
    // 删除所选的数据  2表
    // handleDelete1_2(index) {
    //   this.tenant.snCompanyOrderAttributeDTOS.splice(index, 1);
    // },
    // AddListRow1_2() {

    //   this.tenant.snCompanyOrderAttributeDTOS.push({})
    // },
    // // 上传成功
    // handleSuccess(response, file) {
    //   // 上传成功后，隐藏上传按钮
    //   this.upload_btn = true;
    //   // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
    //   // Vue.set(this.tenant.shopPhoto, 'pic', res.data.url)

    // },
    // handleRemove(response, file) {
    //   // 上传成功后，显示上传按钮
    //   this.upload_btn = false;
    // },

    // // 上传成功
    // handleSuccess4(res, file, picIndex) {
    //   // 上传成功后，隐藏上传按钮
    //   this.upload_btn4 = true;
    //   // this.tenant.snCompanyBrandDTOS[picIndex].pic = res.data.url;
    //   Vue.set(this.tenant.businessPhoto,)

    // },
    // handleRemove4(response, file) {
    //   // 上传成功后，显示上传按钮
    //   this.upload_btn4 = false;
    // },
    // handleDelete2(index) {
    //   this.table_area.splice(index, 1);
    // },
    // handleDelete(index) {
    //   this.table_type.splice(index, 1);
    // },

    // 第一个  表格
    // formatter(row, column) {
    //   return row.isNeedReturn == 1 ? '是' : '否'
    // },
    // formatter1(row, column) {
    //   return row.isCheck == 1 ? '是' : '否'
    // },
    // formatter2(row, column) {
    //   return row.isPast == 1 ? '是' : '否'
    // },
    // formatter3(row, column) {
    //   if (row.afterFlow == 1) {
    //     return "必访"
    //   } else if (row.afterFlow == 2) {
    //     return '申诉'
    //   } else if (row.afterFlow == 3) {
    //     return '挂起'
    //   } else if (row.afterFlow == 4) {
    //     return '重新完工'
    //   } else if (row.afterFlow == 9) {
    //     return '关闭'
    //   }

    // },
    // 卡片事件
    //点击查看图片
    // handlePictureCardPreview(file) {
    //   this.dialogImageUrl = file.url;
    //   this.dialogVisible = true;
    //   // console.log(fileList, "已上传文件")
    // },
    // // 上传发生变化钩子
    // // 注意 :on-remove="handleimageChange"与:on-change="handleimageChange" 都绑定这个方法，这样无论是上传图片还是移除图片，都会更新图片数据列表
    // handleimageChange(file, fileList) {
    //   this.upload_img = fileList;
    //   // this.upload_img.imageName=fileList.name;
    //   console.log(fileList, "文件状态改变时")
    //   console.log(file, "文件状态改变时file")
    // },
  },
};
</script>
<style lang="scss" scoped>
#containt .detail-wrap .d-header {
  margin: -6px 0px 0 -12px !important;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
}

.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    display: inline-block;
    width: 80px!important;;
  }
}
::v-deep .el-radio__label {
    padding-left: 10px;
    display: inline-block!important;
    width: 60px;
}
.header_dialog {
  border-radius: 8px !important;
  height: 800px !important;
}

el-dialog {
  border-radius: 8px !important;
  box-shadow: 0 0 24px rgb(0 0 0 / 22%) !important;
}

v::deep .el-upload .el-upload--picture-card {
  position: relative;
  left: -200px;
}

// 单选框
.radio_item {
  width: 24%;
  margin-top: 10px;
  margin-bottom: 10px !important;

  >span {
    display: inline-block;
    width: 120px;
    margin-right: 13px;
    text-align: right;
    font-weight: 400;
    color: rgba(86, 86, 86, 0.96);
    font-size: 12px;
  }
}

.firm {
  .el-input {
    width: 150px;
  }
}

.type_title {
  font-weight: 400;
  text-align: right;
  width: 112px;
  position: relative;
  padding: 0 10px 0 4px;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

.type_select {
  width: 120px;
  text-align: center;
}

.type_brand {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;

  >div {
    margin: 16px 0;
    width: 25%;
  }
}

// 备注的样式
.annotate {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

.el-textarea__inner {
  padding: 0px !important;
  height: 28px !important;
  min-height: 28px !important;
}

// 装图片的  大框
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  width: 40px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 40px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

// 输入框的宽度
// #containt .table-detail tbody tr td .el-input {
//   width: 100% !important;
//   width: 0 !important;
// }

// Switch 开关  标题的宽度
.el-switch__label * {
  line-height: 1;
  width: 160px !important;
  display: inline-block;
  font-weight: 400;
  color: rgba(86, 86, 86, 0.96);
  font-size: 12px;
}

// 清楚表格 默认padding
.el-table--medium .el-table__cell {
  padding: 0px 0 !important;
}

.table_item {
  .el-table__row:hover>td {
    background-color: #D4E7FF !important;
  }
}

.pic_item {

  .el-upload--picture-card {
    margin-top: 1px;
    width: 36px !important;
    height: 36px !important;
    line-height: 46px !important;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

.papers {
  margin-left: 30px;
  position: absolute;

  ::v-deep.el-upload-list .el-upload-list__item {
    display: inline-block;
    width: 147px !important;
    margin-right: 14px;
    border-radius: 2px;
    border-color: #e8e8e8;
    margin-top: 7px;
    margin-left: 15px;
    padding: 0px !important;
    background-color: #e1e1e1;
    height: 20px;
  }

}

.btn_zdy {
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

.btn_zdy2 {
  // 选取文件合同按钮
  // margin: 10px 60px;
  margin-top: 6px;
  border: 1px solid #dcdfe6 !important;
  border-color: #dcdfe6 !important;
  color: #606266 !important;
  font-weight: 400;
  text-align: center;
  background-color: #FBFBFB !important;
}

.btn_zdy2:hover {
  color: #00c4b3 !important;
  border: 1px solid #00c4b3 !important;
}

::v-deep .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 0 0px !important;
}

// 步骤条
::v-deep .el-card__body,
.el-main {
  padding: 0px !important;
  font-size: 12px;
}

.task {
  color: #62f382;
}

.card {
  padding: 0px 5px;
  background-color: #efefef;
}

.el-timeline {
  margin-top: 40px;
  margin: 0;
  list-style: none;
  margin-left: 6px;
  border: 1px solid #fbfbfb;
  padding-top: 12px;
  height: 380px;
  overflow-y: scroll;
  background-color: #f2f2f2;
  padding-left: 10px !important;
}

.title_icon1 {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #409EFF;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

.title_icon {
  display: inline-block;
  background: rgba(42, 100, 148, 0.16);
  width: 19px;
  background-color: #00c4b3;
  color: #fff;
  text-align: center;
  margin-bottom: 15px;
}

::v-deep .el-timeline-item__node {
  background-color: #ffffff !important;
  border: 1px solid #0550ef;
}

.bread {
  span {
    color: rgba(86, 86, 86, 0.96) !important;
  }

  ::v-deep .el-collapse-item__content {
    padding-bottom: 0px;
    background-color: #efefef;

  }
}

.card_bread {
  position: relative !important;
}

::v-deep .el-tabs__content {
  overflow: visible !important;

}

#containt .detail-wrap .d-cont {
  overflow: unset !important;
}

// .el-timeline-item {
//   position: relative;
//   padding-bottom: 0px !important;
//   margin-left: 47px;
// }
.el-timeline-item[data-v-2cf56cc1] {
  position: relative;
  margin-left: 5px;
  padding-bottom: 0px !important;
}

// 滚动条样式

/* 滚动条 */
::-webkit-scrollbar {
  width: 5px;
  height: 12px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  border-radius: 0px;
  // background: rgba(224, 7, 7, 0.05);
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 00px;
  background: #cfcece;
}

// 步骤条 圆的位置
::v-deep .el-timeline-item__node--normal {
  left: 0px !important;
  width: 12px;
  height: 12px;
}

.el-timeline[data-v-2cf56cc1] {
  position: relative !important;
}

#containt .detail-wrap .d-cont .d-item {
  border: solid 1px #e9e9e9;
  padding: 0 12px 6px;
  position: relative !important;
}

::v-deep .el-collapse-item__arrow {
  position: absolute !important;
  top: 12px !important;
  right: 0 !important;
  font-size: 18px;
  color: #00c4b3 !important;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 0px !important;
}

// 本单费用位置
.expense {
  position: absolute;
  right: 20%;
  margin-top: 5px;
  color: #00c4b3;
  font-size: 13px;
}

::v-deep .el-image__preview {
  width: 60px !important;
  height: 60px !important;
}

.pic_main {
  display: flex;
  margin-left: 75px;
  margin-top: 10px;

  .pic_item {
    display: flex;
    margin-right: 40px;

    span {
      line-height: 60px;
      font-size: 12px;
      color: rgba(86, 86, 86, 0.96);
      font-weight: 400;

    }
  }
}

// 步骤条
.el-steps--simple {
  margin: 20px 0 6px;
}

.el-step.is-simple {
  width: 225px;
}

.audit {
  span {
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
    font-weight: 400;
  }
}

// 卡片样式
.card_item {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;


  .el-card__header {
    padding: 10px 20px 5px;
    border-bottom: 1px dashed #7a7e7c;
    font-weight: 600;
    font-size: 13px;
  }

  .el-card__body,
  .el-main {
    padding: 10px 20px;
  }

  .text {
    font-size: 12px;
  }

  .item {
    margin-bottom: 12px;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .box-card {
    width: 30%;
    margin-right: 30px;
    margin-bottom: 30px;
    border: 1px solid #ccc !important;
  }
}

// 折叠样式对其
// .table-detail {
//   tr{
//     display:block;
//   }
// }
#containt .table-detail tbody tr th {
  display: table-cell;
  vertical-align: middle;
}

#containt .table-detail tbody tr td {

  display: table-cell;
  vertical-align: middle;
}

.title_time {
  margin-top: -13px;
  font-size: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .span1 {
    color: #00c4b3 !important;
    width: 35%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .span2 {
    margin-right: 20px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

}


// 字段之间的距离
#containt .table-detail tbody tr td {
  padding: 5px 12px;
  width: 172.2px;
  height: 27.2px !important;
  word-break: break-word;
}

.information {
  padding: 4px 10px;
  background-color: #E1F2FF;
  color: #268AEA;
  border-radius: 3px;
  margin: 0 5px;
}

#containt .table-detail tbody tr th {
  width: 7vw !important;
}

#containt .table-detail tbody tr td {
  width: 10vw !important;
  ;
}

::v-deep .el-step__title {
  font-size: 11px;
  line-height: 25px;
}

#containt .table-detail tbody tr td[data-v-7297c694] {
  padding: 5px 12px;
  width: 11vw !important;
  height: 27.2px !important;
  word-break: break-word;
}
</style>
